import { ChevronDown, Wand2 } from 'lucide-react';

export function Hero() {
  return (
    <section id="home" className="gradient-hero min-h-screen flex items-center pt-20 px-6 overflow-hidden relative">
      <div className="max-w-7xl mx-auto w-full grid md:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <div className="z-10">
          <div className="flex items-center gap-2 mb-6">
            <span className="text-3xl">👋</span>
            <span className="text-slate-300">Hey, I'm Here</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-black text-white mb-6 leading-tight">
            Tirth <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              Sharma
            </span>
          </h1>
          <p className="text-lg text-slate-300 mb-8 max-w-md">
            Filmmaker & Content Creator bringing stories to life through cinematography, editing, and visual storytelling
          </p>
          <button className="btn-primary bg-cyan-500 hover:bg-cyan-600 flex items-center gap-2">
            <span>Start Exploring</span>
            <Wand2 className="w-4 h-4" />
          </button>

          <div className="mt-16 flex items-center gap-3">
            <span className="text-slate-400">Explore</span>
            <ChevronDown className="w-5 h-5 text-cyan-400 animate-bounce" />
          </div>
        </div>

        {/* Right - Character Placeholder */}
        <div className="relative h-96 md:h-full min-h-96 flex items-center justify-center">
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 via-purple-500/10 to-transparent rounded-3xl blur-3xl"></div>
          <div className="w-64 h-64 md:w-80 md:h-80 bg-gradient-to-br from-slate-800 to-slate-900 rounded-3xl border-2 border-cyan-500/50 flex items-center justify-center relative group">
            <div className="text-center">
              <div className="w-24 h-24 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full mx-auto mb-4 opacity-50 group-hover:opacity-100 transition-opacity"></div>
              <p className="text-slate-400 text-sm">Character Placeholder</p>
              <p className="text-slate-500 text-xs mt-1">(Will animate with cursor)</p>
            </div>
          </div>
        </div>
      </div>

      {/* Glow Effect */}
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-purple-600/20 rounded-full blur-3xl -z-10"></div>
    </section>
  );
}